'use client'
import React from 'react'
import { Modal } from 'antd'
import useI18n from 'Hooks/useI18n'
import { NavbarCloseIcon } from '@/components/svg/enhanced'

interface CommonNoticeModalProps {
  open: boolean
  onClose: () => void
  title: string
  description: string
  confirmButtonText: string
  onConfirm?: () => void
  showActionButton?: boolean
  actionButtonText?: string
  onAction?: () => void
  actionButtonType?: 'primary' | 'secondary'
}

export default function CommonNoticeModal({
  open,
  onClose,
  title,
  description,
  confirmButtonText,
  onConfirm,
  showActionButton = false,
  actionButtonText,
  onAction,
  actionButtonType = 'primary',
}: CommonNoticeModalProps) {
  const { t } = useI18n()

  const handleClose = (event?: React.MouseEvent<HTMLElement>) => {
    event?.stopPropagation()
    onClose()
  }

  const handleConfirm = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    if (onConfirm) {
      onConfirm()
    } else {
      onClose()
    }
  }

  const handleAction = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    if (onAction) {
      onAction()
    }
    onClose()
  }

  return (
    <Modal
      maskClosable={false}
      open={open}
      className="p-0"
      styles={{
        content: {
          padding: 0,
          background: 'transparent',
          boxShadow: 'none',
          color: '#fff',
        },
      }}
      style={{
        paddingBottom: 0,
        top: '20%',
      }}
      transitionName=""
      width={360}
      centered={false}
      footer={null}
      closeIcon={null}
      onCancel={onClose}
    >
      <div
        className="relative rounded-xl backdrop-blur-[25px]"
        style={{
          background:
            'linear-gradient(180deg, rgba(67, 46, 60, 1) 0%, rgba(61, 44, 41, 1) 100%)',
          width: '360px',
          minHeight: 'auto',
        }}
      >
        {/* 关闭按钮 */}
        <button
          type="button"
          aria-label={t('Close')}
          className="absolute right-3 top-3 opacity-40 hover:opacity-60"
          onClick={handleClose}
        >
          <NavbarCloseIcon size={32} color="white" showBackground={false} />
        </button>

        {/* 标题 */}
        <div className="pb-3 pt-8 text-center">
          <h2 className="text-[18px] font-medium leading-tight text-white">
            {title}
          </h2>
        </div>

        {/* 描述 */}
        <div className="px-8 pb-8">
          <p className="text-center text-[15px] leading-[22px] text-white opacity-70">
            {description}
          </p>
        </div>

        {/* 按钮容器 */}
        <div className="flex flex-col gap-3 px-8 pb-8">
          {showActionButton && actionButtonText && (
            <button
              className="h-[44px] w-full rounded-full text-[16px] font-normal text-white transition-opacity hover:opacity-90"
              style={{
                background:
                  actionButtonType === 'primary'
                    ? '#9C4844'
                    : 'rgba(255, 255, 255, 0.1)',
                border:
                  actionButtonType === 'primary'
                    ? 'none'
                    : '1px solid rgba(255, 255, 255, 0.2)',
              }}
              onClick={handleAction}
            >
              {actionButtonText}
            </button>
          )}
          <button
            className="h-[44px] w-full rounded-full text-[16px] font-normal text-white transition-opacity hover:opacity-90"
            style={{
              background: '#9C4844',
            }}
            onClick={handleConfirm}
          >
            {confirmButtonText}
          </button>
        </div>
      </div>
    </Modal>
  )
}
